import { ApiClient, CredentialsService, GeoService } from "@whereby/jslib-api";

const API_BASE_URL = process.env.GATSBY_API_BASE_URL || "http://localhost:8090";

export function initServices() {
    const credentialsService = CredentialsService.create({
        baseUrl: API_BASE_URL,
    });
    const apiClient = new ApiClient({
        baseUrl: API_BASE_URL,
        fetchDeviceCredentials: credentialsService.getCredentials.bind(credentialsService),
    });
    const geoService = new GeoService({
        apiClient,
    });

    return {
        credentialsService,
        apiClient,
        geoService,
    };
}
